const PAYABLE_STATUSES = new Set(["open", "uncollectible"]);

export const isPayableInvoice = (invoice = {}) =>
  PAYABLE_STATUSES.has(invoice.status) && (invoice.amount_due_cents || 0) > 0;

export const countPayableInvoices = (invoices = []) =>
  (invoices || []).filter(isPayableInvoice).length;
